import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';

import baseMixin from '@/mixins/base-component';
import Vuelidate from 'vuelidate';
import VueCookies from 'vue-cookies';
import JsonCSV from 'vue-json-csv'; //TODO? review it
import PortalVue from 'portal-vue';

Vue.config.productionTip = false;
Vue.mixin(baseMixin);
Vue.use(Vuelidate);
Vue.use(VueCookies);
Vue.component('downloadCsv', JsonCSV);
Vue.$cookies.config('7d');
Vue.use(PortalVue);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
